var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.620117,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E3F0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 19.1201V13.4201C26 11.74 26 10.8999 25.673 10.2581C25.3854 9.69366 24.9265 9.23472 24.362 8.9471C23.7202 8.62012 22.8802 8.62012 21.2 8.62012H14.8C13.1198 8.62012 12.2798 8.62012 11.638 8.9471C11.0735 9.23472 10.6146 9.69366 10.327 10.2581C10 10.8999 10 11.74 10 13.4201V23.8201C10 25.5003 10 26.3404 10.327 26.9821C10.6146 27.5466 11.0735 28.0055 11.638 28.2931C12.2798 28.6201 13.1198 28.6201 14.8 28.6201H18M20 17.6201H14M16 21.6201H14M22 13.6201H14M20.5 25.6201L22.5 27.6201L27 23.1201",
    stroke: "#378ED1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/checkList.24026e3ba3a9a35823a2944fd1b8cdd5.svg";
export { ForwardRef as ReactComponent };